import Vue from 'vue'
import Vuex from 'vuex'

import userStore from '@/store/modules/user/index'
import projectStore from '@/store/modules/project/index'
import boardStore from '@/store/modules/board/index'
import styleStore from '@/store/modules/style/index'
import optionStore from '@/store/modules/option/index'
import detailStore from '@/store/modules/detail/index'
import feedbackStore from '@/store/modules/feedback/index'
import uiStore from '@/store/modules/ui/index'

Vue.use(Vuex)

export default new Vuex.Store({
  // Do not enable strict mode for production. https://vuex.vuejs.org/guide/strict.html#development-vs-production
  strict: process.env.NODE_ENV === 'development',
  modules: {
    userStore,
    projectStore,
    boardStore,
    styleStore,
    optionStore,
    detailStore,
    feedbackStore,
    uiStore
  }
})
